export const getJackpotColor = (jackpotIndex: number): string => {
  const colors = ["red", "green", "yellow", "blue"];
  return colors[jackpotIndex % colors.length];
};
